import { useState, useEffect, useCallback } from 'react';

export type ConsentLevel = 'all' | 'essential' | null;

const CONSENT_KEY = 'cookie-consent';

export const useCookieConsent = () => {
  const [consent, setConsent] = useState<ConsentLevel>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY) as ConsentLevel;
    setConsent(stored);
    setIsLoading(false);
  }, []);

  const acceptAll = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'all');
    setConsent('all');
  }, []);

  const acceptEssential = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'essential');
    setConsent('essential');
  }, []);

  const resetConsent = useCallback(() => {
    localStorage.removeItem(CONSENT_KEY);
    setConsent(null);
  }, []);

  const hasConsent = consent !== null;
  const hasFullConsent = consent === 'all';

  return {
    consent,
    isLoading,
    hasConsent,
    hasFullConsent,
    acceptAll,
    acceptEssential,
    resetConsent,
  };
};

// Standalone function to check consent without hook
export const getCookieConsent = (): ConsentLevel => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(CONSENT_KEY) as ConsentLevel;
};

export const hasFullCookieConsent = (): boolean => {
  return getCookieConsent() === 'all';
};
